
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M19 11.0002H7.83005L12.71 6.12016C13.1 5.73016 13.1 5.09016 12.71 4.70016C12.6175 4.60746 12.5076 4.53391 12.3867 4.48373C12.2657 4.43354 12.136 4.40771 12.005 4.40771C11.8741 4.40771 11.7444 4.43354 11.6234 4.48373C11.5024 4.53391 11.3926 4.60746 11.3 4.70016L4.71005 11.2902C4.61734 11.3827 4.5438 11.4926 4.49361 11.6135C4.44343 11.7345 4.4176 11.8642 4.4176 11.9952C4.4176 12.1261 4.44343 12.2558 4.49361 12.3768C4.5438 12.4978 4.61734 12.6076 4.71005 12.7002L11.3 19.2902C11.3926 19.3827 11.5025 19.4562 11.6235 19.5063C11.7445 19.5564 11.8741 19.5822 12.005 19.5822C12.136 19.5822 12.2656 19.5564 12.3866 19.5063C12.5076 19.4562 12.6175 19.3827 12.71 19.2902C12.8026 19.1976 12.8761 19.0877 12.9262 18.9667C12.9763 18.8457 13.0021 18.7161 13.0021 18.5852C13.0021 18.4542 12.9763 18.3246 12.9262 18.2036C12.8761 18.0827 12.8026 17.9727 12.71 17.8802L7.83005 13.0002H19C19.55 13.0002 20 12.5502 20 12.0002C20 11.4502 19.55 11.0002 19 11.0002Z",
        "fill": "#40454E"
      }
    }
  ]
})
    }
  